import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: { fontFamily: "Inter Tight" },
}));

export default useStyles;
